// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let Tooltip = require("./Tooltip.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertySearchResultTitle = require("./PropertySearchResultTitle.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let UseShouldShowPropertyDetails = require("../Hooks/UseShouldShowPropertyDetails.bs.js");
let PropertyLocationForCard_propertyV5_graphql = require("../../../__generated__/PropertyLocationForCard_propertyV5_graphql.bs.js");

let convertFragment = PropertyLocationForCard_propertyV5_graphql.Internal.convertFragment;

function PropertyLocationForCard$Heading(props) {
  return JsxRuntime.jsx(PropertySearchResultTitle.make, {
    detailsHref: props.detailsHref,
    className: props.className,
    children: props.locationDisplay
  });
}

function PropertyLocationForCard(props) {
  let detailsHref = props.detailsHref;
  let className = props.className;
  let property = RescriptRelay_Fragment.useFragment(PropertyLocationForCard_propertyV5_graphql.node, convertFragment, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  let match = property.propertyLocation;
  let tmp;
  if (shouldShowPropertyDetails) {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(PropertyLocationForCard$Heading, {
              locationDisplay: match.locationDisplay,
              detailsHref: detailsHref,
              className: className
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    className: "text-tan-gold-light"
                  })
                }),
                JsxRuntime.jsx("div", {
                  children: "Contact agent for address",
                  className: "text-zinc-600 text-lg font-normal"
                })
              ],
              className: "flex flex-row items-center gap-1"
            })
          ]
        });
        break;
      case "PropertyLocationWithVisibleAddress" :
        let locationDisplay = match.locationDisplay;
        let address = match.address;
        let exit = 0;
        let tmp$1 = match.visibilityRule;
        if (tmp$1 === "VISIBLE_TO_ACCOUNT_MEMBER") {
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(PropertyLocationForCard$Heading, {
                locationDisplay: locationDisplay,
                detailsHref: detailsHref,
                className: className
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "lock",
                      className: "text-tan-gold-light"
                    })
                  }),
                  JsxRuntime.jsx(Tooltip.make, {
                    ariaLabel: address + ` (only visible to you)`,
                    label: address,
                    children: JsxRuntime.jsx("div", {
                      children: "Hidden Address",
                      className: "text-zinc-600 text-lg font-normal relative underline decoration-dotted"
                    })
                  })
                ],
                className: "flex flex-row items-center gap-1"
              })
            ]
          });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(PropertyLocationForCard$Heading, {
                locationDisplay: locationDisplay,
                detailsHref: detailsHref,
                className: className
              }),
              JsxRuntime.jsx("div", {
                children: address,
                className: "text-zinc-600 text-lg font-normal"
              })
            ]
          });
        }
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
  } else {
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        tmp = JsxRuntime.jsx(PropertyLocationForCard$Heading, {
          locationDisplay: match.locationDisplay,
          detailsHref: detailsHref,
          className: className
        });
        break;
      case "PropertyLocationWithVisibleAddress" :
        tmp = JsxRuntime.jsx(PropertyLocationForCard$Heading, {
          locationDisplay: match.locationDisplay,
          detailsHref: detailsHref,
          className: className
        });
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex flex-col gap-1"
  });
}

let make = PropertyLocationForCard;

exports.make = make;
/* IconV5 Not a pure module */
